<template>
  <main id="create-quote-page" class="page-container">
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Modale DUPLICATO preventivo -->
    <VueFinalModal
      v-model="showDuplicateModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content dup-modal__content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="closeDuplicateModal">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Preventivo già presente</h3>

        <p class="dup-modal__intro">
          Esiste già un preventivo per questo cliente allo stesso indirizzo in
          corso...
          <span
            v-if="lastDuplicateQuoteInfo?.address"
            class="dup-modal__address"
          >
            ({{ lastDuplicateQuoteInfo.address }}) </span
          >.
        </p>

        <!-- Stato: loading -->
        <div v-if="dupLoading" class="dup-modal__skeleton">
          Caricamento in corso…
        </div>

        <!-- Stato: errore -->
        <div v-else-if="dupError" class="dup-modal__error">
          {{ dupError }}
        </div>

        <!-- Stato: dati -->
        <div v-else-if="dupQuote" class="dup-quote">
          <div class="dup-quote__grid">
            <div>
              <div class="dup-quote__label">ID</div>
              <div class="dup-quote__value">#{{ dupQuote.id }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Data</div>
              <div class="dup-quote__value">
                {{ formatToLocalDate(dupQuote.date) }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Cliente</div>
              <div class="dup-quote__value">
                {{ dupQuote.clientName || "—" }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Pagamento</div>
              <div class="dup-quote__value">{{ dupQuote.payment_method }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Indirizzo</div>
              <div class="dup-quote__value">
                <a
                  v-if="dupQuote.location?.link"
                  :href="dupQuote.location.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="custom-link"
                >
                  {{ dupQuote.location?.address || "Vedi mappa" }}
                </a>
                <span v-else>{{ dupQuote.location?.address || "—" }}</span>
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Totale</div>
              <div class="dup-quote__value">
                {{ money(dupQuote.totalPrice) }}
              </div>
            </div>
          </div>

          <div class="dup-quote__items">
            <div class="dup-quote__items-head">
              <strong>Riepilogo articoli</strong>
              <span class="muted">({{ dupQuote.items?.length || 0 }})</span>
            </div>
            <ul class="dup-quote__items-list">
              <li
                v-for="(it, idx) in dupQuote.items || []"
                :key="idx"
                class="dup-item"
              >
                <div class="dup-item__name">
                  {{ it.itemName || it.brand || "Articolo" }}
                </div>
                <div class="dup-item__meta">
                  <span v-if="it.category" class="chip">{{ it.category }}</span>
                  <span v-if="it.boxQuantity"
                    >scatole: {{ it.boxQuantity }}</span
                  >
                  <span v-if="it.pieces">pezzi: {{ it.pieces }}</span>
                  <span v-if="it.iva !== undefined">IVA: {{ it.iva }}%</span>
                  <span v-if="it.price !== undefined"
                    >€ {{ number(it.price) }}</span
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="dup-modal__footer">
          <!-- Apri file (si vede solo se ho caricato docs) -->
          <button
            v-if="dupQuote && !dupLoading && dupDocuments.length"
            class="btn-primary"
            @click="showDupDocs = true"
          >
            Apri file
          </button>
          <!-- <router-link
            v-if="lastDuplicateQuoteInfo?.quoteId"
            class="btn primary"
            :to="`/quote/${lastDuplicateQuoteInfo.quoteId}`"
            @click="onViewedExisting"
          >
            Apri preventivo esistente
          </router-link> -->

          <button class="btn-primary" @click="onChangeAddress">
            Usa indirizzo diverso
          </button>

          <button
            class="btn-ghost"
            :disabled="!lastDuplicateQuoteInfo?.quoteId"
            @click="onDuplicateWithEdit"
          >
            Duplica modificando indirizzo
          </button>
        </div>

        <!-- DEV: riquadro debug, rimuovi quando hai finito -->
        <!-- <div
          v-if="showDuplicateModal"
          style="margin-top: 12px; font-size: 12px; color: #555"
        >
          <details>
            <summary>Debug dup</summary>
            <pre style="white-space: pre-wrap; word-break: break-word">
lastDuplicateQuoteInfo: {{ lastDuplicateQuoteInfo }}
dupLoading: {{ dupLoading }}
dupError: {{ dupError }}
dupQuote: {{ dupQuote }}
    </pre
            >
          </details>
        </div> -->
      </template>
    </VueFinalModal>

    <VueFinalModal
      v-model="showDupDocs"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="documents-modal-content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="showDupDocs = false">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Preventivo #{{ dupQuote?.id }}</h3>

        <div class="documents-grid">
          <div v-for="doc in dupDocuments" :key="doc.id" class="document-card">
            <a :href="doc.url" target="_blank" class="card-link">
              <div class="card-icon-pdf">
                <i class="fa-solid fa-file-pdf"></i>
              </div>
              <div class="card-body">
                <div class="card-title">{{ formatDocName(doc.name) }}</div>
                <div class="card-subtitle">
                  Data di creazione: {{ formatToLocalDate(doc.createdAt) }}
                </div>
              </div>
            </a>
          </div>

          <div v-if="dupDocuments.length === 0" class="no-result">
            Nessun documento trovato
          </div>
        </div>
      </template>
    </VueFinalModal>

    <div class="create-quote-wrapper">
      <div class="create-quote-main-col" ref="mainCol">
        <!-- Form principale -->
        <form
          class="create-quote-form"
          @submit.prevent="onCreateQuoteAndGeneratePdf"
        >
          <!-- SEZIONE: Anagrafica preventivo -->
          <section class="quote-section">
            <h3 class="quote-section__title">
              <i class="fa-solid fa-file-lines"></i> Anagrafica preventivo
            </h3>
            <div class="quote-section__grid">
              <!-- Colonna 1: Cliente + Modalità di pagamento -->
              <div class="quote-section__col">
                <!-- Seleziona Cliente -->
                <div class="field" id="client-select">
                  <label>Cliente</label>
                  <SearchableCombo
                    v-model="formData.clientId"
                    :items="comboClients"
                    :labelKey="
                      (c) =>
                        c.email
                          ? `${c.clientName} - (${c.email})`
                          : c.pec
                          ? `${c.clientName} - (${c.pec})`
                          : c.clientName
                    "
                    :valueKey="(c) => c.id"
                    placeholder="Cerca cliente..."
                    :loading="clientsLoading"
                    emptyText="Nessun risultato"
                    @search="onSearchClient"
                    @select="selectClient"
                  />
                </div>

                <!-- Modalità di pagamento -->
                <div class="field">
                  <label for="payment-method">Modalità di pagamento</label>
                  <StatusSelect
                    v-model="formData.payment_method"
                    :options="paymentOptions"
                    placeholder="Seleziona metodo..."
                    placeholderIcon="fa-wallet"
                  />
                </div>
              </div>

              <!-- Colonna 2: Data + Indirizzo -->
              <div class="quote-section__col">
                <!-- Data Preventivo -->
                <div class="field">
                  <label for="date">Data</label>
                  <FlatPickr
                    id="date"
                    v-model="formData.date"
                    :config="dateConfig"
                    placeholder="gg/mm/aaaa"
                  />
                </div>

                <!-- Indirizzo: sempre visibile; readonly + nota "Ritiro in sede" quando non è consegna -->
                <div class="field">
                  <label for="address">Indirizzo di consegna</label>
                  <input
                    type="text"
                    id="address"
                    v-model="addressModel"
                    :readonly="formData.deliveryType !== 'consegna'"
                    :class="{
                      'readonly-field': formData.deliveryType !== 'consegna',
                    }"
                    placeholder="Inserisci indirizzo completo…"
                    autocomplete="off"
                  />
                </div>
              </div>

              <!-- Colonna 3: Modalità di consegna -->
              <div class="quote-section__col">
                <div class="field">
                  <label>
                    Modalità di consegna <span class="required-mark">*</span>
                  </label>
                  <StatusSelect
                    v-model="deliveryTypeModel"
                    :options="deliveryOptions"
                    placeholder="Seleziona modalità..."
                    placeholderIcon="fa-truck"
                  />
                </div>
              </div>
            </div>
          </section>

          <!-- RIGA: form articolo (40%) + articoli aggiunti (60%) -->
          <div class="quote-work-row">
            <!-- Colonna sinistra (40%): form articolo + note e addebiti -->
            <div class="quote-work-col">
              <!-- SEZIONE: Articolo (form) -->
              <section class="quote-section">
                <h3 class="quote-section__title">
                  <i class="fa-solid fa-cart-shopping"></i> Articolo
                </h3>
                <div class="quote-section__col">
                  <!-- RIGA 3: scegli articolo, quantità -->
                  <div class="create-quote-row row-3">
                    <!-- scegli Articolo -->
                    <div class="field" id="item-select">
                      <label for="item-search">Articolo</label>
                      <SearchableCombo
                        v-model="newItem.itemId"
                        v-model:text="searchQueryItem"
                        :items="filteredItems"
                        :labelKey="itemSearchLabel"
                        :valueKey="(it) => it.id"
                        placeholder="Cerca articolo..."
                        :disabled="false"
                        :loading="itemsLoading"
                        :current-page="itemsPage"
                        :requested-page="itemsRequestedPage"
                        :total-pages="itemsTotalPages"
                        :total-items="itemsTotalItems"
                        :show-pagination="true"
                        emptyText="Nessun risultato"
                        @search="onSearchItem"
                        @select="selectItem"
                        @page-change="onItemPageChange"
                        @cleared="clearItemSelection"
                      >
                        <template #option="{ option }">
                          <span class="quote-item-option">
                            <span class="quote-item-option__content">
                              <span
                                class="quote-item-option__label"
                                :class="{
                                  'is-out': isOrderableOutOfStock(option),
                                }"
                              >
                                <span v-if="isOrderableOutOfStock(option)"
                                  >! </span
                                >{{ itemSearchLabel(option) }}
                              </span>
                              <span
                                v-if="itemFormatFinish(option)"
                                class="quote-item-option__meta"
                              >
                                {{ itemFormatFinish(option) }}
                              </span>
                            </span>
                            <span
                              class="quote-item-option__stock"
                              :class="{
                                'in-stock': warehouseCount(option) > 0,
                              }"
                              :title="stockTitle(option)"
                            >
                              {{ stockLabel(option) }}
                            </span>
                          </span>
                        </template>
                      </SearchableCombo>
                      <p class="create-item-cta">
                        Articolo non trovato?
                        <button
                          type="button"
                          class="create-item-link"
                          @click.prevent.stop="openCreateItemModal"
                        >
                          <i class="fa-solid fa-circle-plus"></i> Crea articolo
                        </button>
                      </p>
                    </div>

                    <!-- Quantità a pezzi: solo per articoli non venduti a scatola -->
                    <div class="field" v-if="!showMqField">
                      <label :for="'quantity'">{{ quantityLabel }}</label>
                      <input
                        id="quantity"
                        type="number"
                        min="1"
                        step="1"
                        v-model="quantityInput"
                        placeholder="Inserisci quantità"
                      />
                    </div>
                    <!-- Articoli a mq/ml: si scrivono i mq e basta. Le scatole intere
                         necessarie sono derivate dietro le quinte e mostrate nell'hint. -->
                    <div class="field" v-else>
                      <label for="mq-per-box">{{ mqFieldLabel }}</label>
                      <input
                        id="mq-per-box"
                        type="number"
                        min="0"
                        step="any"
                        v-model="mqInput"
                        placeholder="Inserisci i mq"
                      />
                      <!-- Dati scatola incompleti: l'articolo si può comunque
                           preventivare, ma la scheda va completata prima di
                           confermare il preventivo al cliente. -->
                      <small
                        v-if="missingBoxDataInfo"
                        class="field-warning"
                        role="alert"
                      >
                        {{ missingBoxDataInfo.text }}
                        <router-link
                          :to="missingBoxDataInfo.route"
                          target="_blank"
                          class="field-warning-link"
                          >Completa la scheda articolo</router-link
                        >
                      </small>
                      <small v-if="mqSummary" class="field-hint">{{
                        mqSummary
                      }}</small>
                    </div>
                  </div>
                  <!-- Flusso prezzo (IVA esclusa): listino → scontato → IVA -->
                  <div class="create-quote-row row-4 price-flow">
                    <!-- 1) Prezzo di listino NETTO (IVA esclusa), readonly -->
                    <div class="field">
                      <label for="price">Prezzo listino — IVA esclusa</label>
                      <input
                        id="price"
                        type="number"
                        v-model="newItem.price"
                        placeholder="Seleziona l'articolo per visualizzare il prezzo corrispondente"
                        step="0.01"
                        readonly
                        class="readonly-field"
                      />
                    </div>
                    <i
                      class="fa-solid fa-arrow-right price-flow__arrow"
                      aria-hidden="true"
                    ></i>
                    <!-- 2) Prezzo scontato NETTO (opzionale): prezzo netto da
                 applicare, digitato dall'operatore. Vuoto → usa il listino. -->
                    <div class="field">
                      <label for="discounted-price">Prezzo scontato</label>
                      <input
                        id="discounted-price"
                        type="number"
                        v-model="newItem.discountedPrice"
                        placeholder="Prezzo netto scontato (opzionale)"
                        step="0.01"
                        min="0"
                      />
                    </div>
                    <i
                      class="fa-solid fa-arrow-right price-flow__arrow"
                      aria-hidden="true"
                    ></i>
                    <!-- 3) IVA applicata alla riga (default 0%) -->
                    <div class="field">
                      <label for="vat-rate">IVA</label>
                      <StatusSelect
                        v-model="newItem.iva"
                        :options="ivaOptions"
                        placeholderIcon="fa-percent"
                      />
                    </div>
                  </div>

                  <!-- Anteprima riga: imponibile → imposta → totale (IVA esclusa
                       → ivato). Solo preview, non input. -->
                  <div class="create-quote-row line-preview">
                    <span class="line-preview__item"
                      >Imponibile:
                      <strong>€ {{ previewFormatted.taxable }}</strong></span
                    >
                    <span class="line-preview__item"
                      >Aliquota: <strong>{{ newItem.iva }}%</strong></span
                    >
                    <span class="line-preview__item"
                      >Imposta:
                      <strong>€ {{ previewFormatted.tax }}</strong></span
                    >
                    <span class="line-preview__item line-preview__total"
                      >Totale:
                      <strong>€ {{ previewFormatted.gross }}</strong></span
                    >
                  </div>

                  <!-- RIGA 3: bottone "+ aggiungi articolo" + "Mostra articoli" -->
                  <div class="create-quote-row row-5">
                    <!-- Bottone per aggiungere un ulteriore alla lista -->
                    <div class="field">
                      <button
                        type="button"
                        class="add-item-btn"
                        :disabled="!canAddItem"
                        @click="addItem"
                      >
                        <!-- icona -->
                        <i class="fa-solid fa-plus icon" aria-hidden="true"></i>
                        <span>aggiungi articolo</span>
                      </button>
                    </div>
                  </div>
                </div>
              </section>

              <!-- SEZIONE: Note e addebiti (sotto il form articolo) -->
              <section class="quote-section">
                <h3 class="quote-section__title">
                  <i class="fa-solid fa-note-sticky"></i> Note e addebiti
                </h3>
                <!-- RIGA 6: note + cambio lingua -->
                <div class="create-quote-row row-5 notes-row">
                  <!-- Richieste tecniche -->
                  <div class="field">
                    <label for="technical-requests">Note</label>
                    <textarea
                      id="technical-requests"
                      v-model.trim="formData.technical_queries"
                      placeholder="Inserisci note"
                      maxlength="2000"
                      rows="3"
                    ></textarea>
                  </div>
                </div>

                <!-- RIGA 7: Addebiti -->
                <div class="create-quote-row addebiti-row">
                  <div class="field">
                    <label>Addebiti</label>
                    <hr />
                    <div class="addebiti-line">
                      <span class="addebiti-label">Spesa imballo (€30,00)</span>
                      <label class="addebiti-option">
                        <input
                          type="radio"
                          :value="false"
                          v-model="formData.hasPackagingFee"
                        />
                        No
                      </label>
                      <label class="addebiti-option">
                        <input
                          type="radio"
                          :value="true"
                          v-model="formData.hasPackagingFee"
                        />
                        Sì
                      </label>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <!-- /.quote-work-col -->

            <!-- Colonna destra (60%): articoli aggiunti + salva -->
            <div class="quote-work-col">
              <!-- Articoli aggiunti -->
              <aside class="items-panel" ref="itemsPanel">
                <div class="items-panel__title-bar">
                  <h3 class="items-panel__title">Articoli aggiunti</h3>
                </div>
                <div class="items-panel__table-wrap">
                  <table class="items-panel__table">
                    <thead>
                      <tr>
                        <th>Codice</th>
                        <th>Articolo</th>
                        <th>Categoria</th>
                        <th>Quantità</th>
                        <th>Prezzo</th>
                        <th>IVA</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, idx) in formData.items"
                        :key="`stk-${item.itemId}-${item.iva}`"
                        :class="{
                          'quote-item-row--incomplete':
                            isRowStockIncomplete(item),
                        }"
                        :title="rowStockWarning(item)"
                      >
                        <td class="item-code-cell">
                          {{
                            getItemFromStore(
                              item.itemId,
                              categoryHintForRow(item)
                            ).supplierCode ||
                            getItemFromStore(
                              item.itemId,
                              categoryHintForRow(item)
                            ).itemCode ||
                            "—"
                          }}
                        </td>
                        <td class="item-cell">
                          <div class="item-title">
                            {{ itemDisplay(item).title }}
                          </div>
                          <div v-if="itemDisplay(item).meta" class="item-meta">
                            {{ itemDisplay(item).meta }}
                          </div>
                        </td>
                        <td>
                          {{
                            getItemFromStore(
                              item.itemId,
                              categoryHintForRow(item)
                            ).category
                          }}
                        </td>
                        <td>
                          <input
                            type="number"
                            class="panel-qty-input"
                            :value="rowQtyValue(item)"
                            :step="rowQtyStep(item)"
                            :title="rowQtyTitle(item)"
                            min="0"
                            @change="
                              updateRowQty(
                                item,
                                +$event.target.value,
                                $event.target
                              )
                            "
                          />
                          <span class="panel-qty-unit">{{
                            rowQtyUnit(item)
                          }}</span>
                          <!-- Disponibilità mostrata solo se le scatole sono
                               calcolabili: senza mq/ml per scatola i numeri
                               sarebbero inventati. -->
                          <template
                            v-if="
                              rowHasBoxData(item) &&
                              isOrderableOutOfStock(
                                getItemFromStore(
                                  item.itemId,
                                  categoryHintForRow(item)
                                )
                              )
                            "
                          >
                            <span class="item-order-queued-badge"
                              >Esaurito</span
                            >
                            <span class="item-order-info-msg"
                              >Necessario ordinarlo per la quantità
                              richiesta.</span
                            >
                          </template>
                          <template
                            v-else-if="
                              rowHasBoxData(item) && isQtyExceedingStock(item)
                            "
                          >
                            <span
                              class="item-order-queued-badge item-not-available-badge"
                              >Non disponibile</span
                            >
                            <span class="item-order-info-msg"
                              >Necessario ordinarne
                              {{ qtyToOrderLabel(item) }} per la quantità
                              richiesta.</span
                            >
                          </template>
                        </td>
                        <td>
                          {{ formatPrice(item.price) }}
                          {{ unitForRow(item) }}
                        </td>
                        <td>{{ formatIva(item.iva) }}</td>
                        <td>
                          <button
                            type="button"
                            class="icons-button"
                            @click="removeItem(idx)"
                            title="Rimuovi articolo dalla lista"
                            aria-label="Rimuovi articolo dalla lista"
                          >
                            <i class="fa-solid fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="formData.items.length === 0">
                        <td colspan="7" class="no-result">
                          Nessun articolo presente
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="items-panel__footer">
                  {{ formData.items.length }}
                  {{ formData.items.length === 1 ? "articolo" : "articoli" }}
                </div>
              </aside>

              <!-- Salva ed esporta: sotto il riepilogo articoli aggiunti -->
              <div class="save-button-container">
                <button
                  id="save-quote"
                  type="button"
                  class="primary-btn"
                  @click="onCreateQuoteAndGeneratePdf"
                  :disabled="!canSaveCreate"
                  :title="
                    !canSaveCreate
                      ? 'Compila tutti i campi obbligatori per salvare il preventivo'
                      : 'Salva preventivo ed esporta PDF'
                  "
                >
                  Salva ed esporta PDF
                </button>
              </div>
            </div>
            <!-- /.quote-work-col -->
          </div>
          <!-- /.quote-work-row -->
        </form>
      </div>
      <!-- /.create-quote-main-col -->
    </div>
    <!-- /.create-quote-wrapper -->

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>

    <!-- Modale "Crea articolo": crea l'articolo e lo auto-seleziona nel preventivo -->
    <CreateItemModal
      v-model="showCreateItemModal"
      :initial-name="searchQueryItem"
      @created="onItemCreated"
    />
  </main>
</template>

<script>
import logoPath from "@/assets/logo-liberotratto.png";
// import crypto from "crypto";
import axiosInstance from "@/axiosInstance";
import { generateQuotePdf } from "@/utilities/generateQuotePdf";
import {
  missingStockFields,
  hasIncompleteStockData,
  itemPerBox,
} from "@/utilities/itemStockData";
import debounce from "lodash/debounce";
import { trackEvent, EVENTS } from "@/utilities/analytics";
// import { nextTick } from "process";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDate, formatDecimal } from "../utilities/formatting";
import SearchableCombo from "./SearchableCombo.vue";
import StatusSelect from "@/components/StatusSelect.vue";
import CreateItemModal from "@/components/CreateItemModal.vue";
import FlatPickr from "vue-flatpickr-component";
import { Italian } from "flatpickr/dist/l10n/it.js";
// import DuplicateQuoteModal from "./DuplicateQuoteModal.vue";

const KEY = {
  STOCK: (id) => `STOCK:${Number(id)}`,
};

const COLUMN_GROUPS = {
  area: [
    "piastrelle",
    "rivestimenti parete",
    "parquet",
    "laminati",
    "decking esterno",
  ],
  piece: ["sanitari", "rubinetteria", "box doccia", "accessori bagno"],
  linear: ["profili", "sistemi di scarico"],
  furniture: ["mobili", "porte e infissi"],
};

function getCategoryGroup(category) {
  for (const [group, cats] of Object.entries(COLUMN_GROUPS)) {
    if (cats.includes(category)) return group;
  }
  return "generic";
}

/* Categorie vendute a scatola/confezione (la quantità va in boxQuantity,
   non in pieces): tutto il gruppo area + linear, non solo le piastrelle. */
function isBoxBasedCategory(category) {
  const g = getCategoryGroup(category);
  return g === "area" || g === "linear";
}

/* Quantità in mq/ml corrispondente a N scatole, come multiplo esatto di
   perBox (evita 3 x 1,44 = 4,319999...). Stringa pronta per il campo input:
   punto decimale, zeri finali rimossi. */
function quantityFromBoxes(boxes, perBox) {
  const n = Number(boxes) || 0;
  const scaled = Math.round((Number(perBox) || 0) * 10000);
  if (!n || !scaled) return "";
  return ((n * scaled) / 10000)
    .toFixed(4)
    .replace(/0+$/, "")
    .replace(/\.$/, "");
}

/* Scatole intere necessarie per una quantità in mq/ml.
   Arrotonda per eccesso (si comprano scatole intere) ma con tolleranza: senza,
   l'errore float o l'arrotondamento del campo fa scattare una scatola in più
   (es. 4,32 / 1,44 = 3.0000000000000004 -> ceil = 4 scatole invece di 3). */
function boxesFromQuantity(quantity, perBox) {
  const qty = Number(quantity) || 0;
  const step = Number(perBox) || 0;
  if (!step || qty <= 0) return 0;
  const ratio = qty / step;
  const nearest = Math.round(ratio);
  const tolerance = Math.min(0.005 / step, 0.01);
  return Math.abs(ratio - nearest) <= tolerance ? nearest : Math.ceil(ratio);
}

// mq/ml persistiti dall'API: null sulle righe storiche e sugli articoli a pezzo
function mqFromApi(value) {
  const n = Number(value);
  return n > 0 ? n : null;
}

// mq/ml per scatola con fallback: se l'articolo non ha il dato, si assume
// 1 unità per scatola — stessa assunzione dell'API nel calcolo del totale
// (COALESCE(sqmPerBox, 1)) — così l'articolo resta comunque preventivabile.
function perBoxOrFallback(perBox) {
  const n = Number(perBox) || 0;
  return n > 0 ? n : 1;
}

// 👇 helper per location: stringa JSON o oggetto
const asLoc = (raw) => {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw; // è già un oggetto
};

export default {
  components: { SearchableCombo, StatusSelect, CreateItemModal, FlatPickr },
  beforeRouteLeave(to) {
    if (
      this.navigationConfirmed ||
      to.name === "login" ||
      !this.hasUnsavedChanges
    ) {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  created() {
    this.$store
      .dispatch("fetchClients", {
        limit: 10000,
      })
      .catch((err) => {
        // evita Uncaught (in promise)
        console.error("Impossibile caricare i clienti: ", err.message);
        // puoi mostrare un toast o impostare un flag di errore
      });
    // this.$store.dispatch("fetchOperators");
    this.$store
      .dispatch("fetchItems", {
        limit: 10000,
      })
      .catch((err) => {
        // evita Uncaught (in promise)
        console.error("Impossibile caricare gli articoli: ", err.message);
        // puoi mostrare un toast o impostare un flag di errore
      });
    this.debouncedFetchItems = debounce(this.fetchItems, 200);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  computed: {
    clients() {
      return this.$store.getters["clients/list"] ?? [];
    },
    // Indirizzo mostrato nel campo: "Ritiro in sede" quando non è consegna
    // (solo visuale; il valore reale formData.location.address resta invariato)
    addressModel: {
      get() {
        return this.formData.deliveryType === "ritiro"
          ? "Ritiro in sede"
          : this.formData.location.address;
      },
      set(v) {
        if (this.formData.deliveryType === "consegna") {
          this.formData.location.address = v;
        }
      },
    },
    // Ponte UI per la select "Modalità di consegna": il payload resta
    // "consegna" | "ritiro" | "". Stessa logica di azzeramento indirizzo.
    deliveryTypeModel: {
      get() {
        return this.formData.deliveryType;
      },
      set(v) {
        this.formData.deliveryType = v || "";
        if (this.formData.deliveryType !== "consegna") {
          this.formData.location.address = "";
        }
      },
    },
    selectedItem() {
      if (this.newItem.itemId) {
        return this.getItemFromStore(this.newItem.itemId, "STOCK");
      }
      return {};
    },
    selectedItemGroup() {
      return getCategoryGroup(this.selectedItem?.category);
    },
    quantityLabel() {
      if (this.selectedItemGroup === "area") return "Quantità scatole";
      if (this.selectedItemGroup === "linear") return "Quantità confezioni";
      return "Quantità pezzi";
    },
    mqFieldLabel() {
      if (this.selectedItemGroup === "linear") return "Quantità ML";
      return "Quantità Mq";
    },

    /* Ponte per v-model quantityInput */
    quantityInput: {
      get() {
        if (
          this.selectedItemGroup === "area" ||
          this.selectedItemGroup === "linear"
        ) {
          return this.newItem.boxQuantity;
        }
        return this.newItem.pieces;
      },
      set(v) {
        // scatole/confezioni/pezzi sono sempre interi: niente 2,5 scatole
        const n = Math.max(0, Math.round(+v || 0));
        if (this.selectedItemGroup === "area") {
          this.newItem.boxQuantity = n;
          const ppb = this.selectedItem.piecesPerBox || 1;
          this.newItem.pieces = n * ppb;
        } else if (this.selectedItemGroup === "linear") {
          this.newItem.boxQuantity = n;
          this.newItem.pieces = 0;
        } else {
          this.newItem.pieces = n;
        }
      },
    },

    /* Abilita "aggiungi articolo" solo con quantità numerica > 0 */
    canAddItem() {
      const hasSelectedItem = Boolean(this.newItem.itemId);
      const isAreaOrLinear =
        this.selectedItemGroup === "area" ||
        this.selectedItemGroup === "linear";
      const qty = isAreaOrLinear
        ? Number(this.newItem.boxQuantity)
        : Number(this.newItem.pieces);
      return hasSelectedItem && Number.isFinite(qty) && qty >= 1;
    },

    /* Articolo a mq/ml con la scheda incompleta: si può comunque preventivare,
       ma senza mq/scatola e pz/scatola il preventivo non è confermabile.
       Restituisce l'avviso e la rotta per completare la scheda. */
    missingBoxDataInfo() {
      const item = this.selectedItem;
      if (!this.showMqField || !item?.id) return null;
      const missing = missingStockFields(item);
      if (!missing.length) return null;
      return {
        text: `Scheda articolo incompleta (manca ${missing.join(
          ", "
        )}): puoi aggiungere l'articolo al preventivo, ma completa la scheda prima di confermarlo al cliente.`,
        route: {
          name: "listini-edit-item",
          params: { category: item.category, itemId: item.id },
        },
      };
    },

    /* mq/ml per scatola dell'articolo selezionato: passo di incremento del
       campo mq (una freccia = una scatola) */
    mqPerBox() {
      const s = this.selectedItem || {};
      const perBox =
        this.selectedItemGroup === "linear"
          ? Number(s.mlPerBox) || 0
          : Number(s.sqmPerBox) || 0;
      return perBox > 0 ? perBox : 0;
    },

    /* Riepilogo sotto il campo mq: l'operatore scrive i mq, ma il preventivo va
       a scatole intere. L'hint rende esplicito cosa viene effettivamente venduto. */
    mqSummary() {
      if (!this.showMqField) return "";
      const perBox = this.mqPerBox;
      // dato mancante: al posto del riepilogo si mostra l'avviso con il link
      if (!perBox) return "";
      const boxes = Number(this.newItem.boxQuantity) || 0;
      const isLinear = this.selectedItemGroup === "linear";
      const unit = isLinear ? "ml" : "mq";
      if (!boxes) return `${formatDecimal(perBox)} ${unit}/scatola`;
      const label = isLinear ? "confezioni" : "scatole";
      const total = formatDecimal(quantityFromBoxes(boxes, perBox));
      const ppb = Number(this.selectedItem?.piecesPerBox) || 0;
      const pieces = !isLinear && ppb ? ` · ${boxes * ppb} pz totali` : "";
      return `${boxes} ${label} = ${total} ${unit}${pieces}`;
    },

    /* Anteprima riga (nuova semantica IVA esclusa): netto applicato, quantità
       effettiva, e importi imponibile/imposta/totale dell'intera riga. Valori 0
       se la quantità non è ancora valida (nessun NaN). */
    previewAppliedNet() {
      const personalized = this.optionalNonNegativeNumber(
        this.newItem.discountedPrice
      );
      return personalized !== null
        ? personalized
        : Number(this.newItem.price) || 0;
    },
    previewEffectiveQty() {
      const group = this.selectedItemGroup;
      if (group === "area" || group === "linear") {
        const typed = this.typedMqQuantity();
        if (typed !== null) return Number(typed) || 0;
        return quantityFromBoxes(
          Number(this.newItem.boxQuantity) || 0,
          perBoxOrFallback(this.mqPerBox)
        );
      }
      return Number(this.newItem.pieces) || 0;
    },
    linePreview() {
      const net = Number(this.previewAppliedNet) || 0;
      const qty = Number(this.previewEffectiveQty) || 0;
      const iva = Number(this.newItem.iva) || 0;
      const taxable = +(net * qty).toFixed(2);
      const tax = +((taxable * iva) / 100).toFixed(2);
      const gross = +(taxable + tax).toFixed(2);
      return { taxable, tax, gross };
    },
    previewFormatted() {
      const p = this.linePreview;
      return {
        taxable: formatDecimal(p.taxable),
        tax: formatDecimal(p.tax),
        gross: formatDecimal(p.gross),
      };
    },

    showMqField() {
      const s = this.selectedItem || {};
      if (!s || !s.category) return false;
      return (
        this.selectedItemGroup === "area" || this.selectedItemGroup === "linear"
      );
    },

    items() {
      return this.$store.getters["items/list"] ?? [];
    },

    filteredClients() {
      const query = (this.searchQueryClient || "").toLowerCase();
      // console.log("thisclients", this.clients);
      return this.clients
        .filter((c) => (c.clientName || "").toLowerCase().includes(query))
        .slice(0, 5);
    },

    // Tutti i nomi da mostrare nella colonna "Articolo"
    itemNames() {
      return (this.formData.items || []).map(
        (row) =>
          this.getItemName(row.itemId, this.categoryHintForRow(row)) || ""
      );
    },

    // Lunghezza massima in caratteri tra i nomi
    maxItemLen() {
      return this.itemNames.reduce((m, s) => Math.max(m, s.length), 0);
    },

    // Larghezza dinamica della colonna "Articolo" in ch, con limiti per non rompere il layout
    // - min 180px (leggibile anche con nomi brevi)
    // - valore centrale in ch (caratteri) = maxArtLen + 6 (un po' di respiro)
    // - max 52vw (mai oltre metà viewport nel modale)
    itemColWidth() {
      const ch = Math.max(10, Math.min(this.maxItemLen + 6, 72)); // clamp “logico”
      return `clamp(180px, ${ch}ch, 50vw)`;
    },

    showSelectedItemOrderAlert() {
      return this.isOrderableOutOfStock(this.selectedItem);
    },
    selectedItemOrderLabel() {
      return this.itemSearchLabel(this.selectedItem);
    },
    canSaveCreate() {
      // indirizzo non obbligatorio, ma è obbligatorio scegliere la modalità
      // (consegna o ritiro) e serve almeno un articolo
      return this.formData.items.length > 0 && !!this.formData.deliveryType;
    },
    hasUnsavedChanges() {
      const f = this.formData;
      return !!(
        (f.items && f.items.length) ||
        (f.location?.address || "").trim() ||
        f.clientId ||
        (f.technical_queries || "").trim() ||
        this.newItem?.itemId
      );
    },
  },
  data() {
    return {
      dateConfig: {
        locale: Italian,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
        allowInput: true,
        monthSelectorType: "static",
      },
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,
      // loading per i 3 combobox
      clientsLoading: false,
      itemsLoading: false,
      // lista clienti filtrata per il combobox (evitiamo il vecchio computed)
      comboClients: [],

      showDuplicateModal: false,
      lastDuplicateQuoteInfo: { quoteId: null, address: null },
      showDupDocs: false,
      dupDocuments: [],
      // Modale "Crea articolo" (richiamo da campo ricerca articolo)
      showCreateItemModal: false,

      dupLoading: false,
      dupError: "",
      dupQuote: null,

      showDropdown: false,
      searchQueryClient: "",
      searchQueryItem: "",
      // mq/ml digitati dall'operatore: valore libero, non riscritto dalla UI.
      // Le scatole del preventivo sono derivate da qui (vedi watcher mqInput).
      mqInput: "",
      filteredItems: [],
      // Paginazione risultati ricerca articolo (fix #2)
      itemsPage: 1, // ultima pagina caricata con successo
      itemsRequestedPage: null, // pagina della richiesta in volo (pending)
      itemsTotalPages: 1,
      itemsTotalItems: null,
      itemsSearchQuery: "",
      itemsRequestId: 0,
      selectedByKey: {},
      pendingOrderItems: {},
      orderNote: "",
      panelVisible: true,
      selectedIndex: -1, // Indice dell'opzione attualmente evidenziata
      activeSearch: null, // "item" o "client" o null
      response: "",

      image: logoPath,
      formData: {
        location: {
          name: "",
          address: "",
          placeId: "",
          latitude: "",
          longitude: "",
        },
        technical_queries: "",
        clientId: "",
        items: [],
        date: "",
        payment_method: "",
        deliveryType: "",
        hasPackagingFee: false,
      },
      newItem: {
        itemId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        discountedPrice: "",
        iva: 0,
      },
      errorMessage: "",
      successMessage: "",
      selectedPlaceId: "",
      paymentOptions: [
        { value: "Contanti", label: "Contanti" },
        { value: "Carta di credito", label: "Carta di credito" },
        { value: "Bonifico", label: "Bonifico" },
        { value: "Scegli successivamente", label: "Scegli successivamente" },
      ],
      deliveryOptions: [
        { value: "consegna", label: "Presso cliente", icon: "fa-truck" },
        { value: "ritiro", label: "Ritiro", icon: "fa-store" },
      ],
      ivaOptions: [
        { value: 22, label: "22%" },
        { value: 10, label: "10%" },
        { value: 4, label: "4%" },
        { value: 0, label: "0%" },
      ],
    };
  },

  methods: {
    goBack() {
      this.pendingNavigation = null;
      // Nessuna modifica: torna indietro senza conferma.
      if (!this.hasUnsavedChanges) {
        this.navigationConfirmed = true;
        this.$router.back();
        return;
      }
      this.showBackModal = true;
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        this.$router.back();
      }
    },
    // Guardia reload/chiusura tab nativa del browser: mostra il dialog
    // nativo di conferma quando ci sono modifiche non salvate.
    handleBeforeUnload(e) {
      if (!this.hasUnsavedChanges) return;
      e.preventDefault();
      e.returnValue = "";
    },
    onSearchClient(q) {
      this.clientsLoading = true;
      const query = (q || "").toLowerCase();
      this.comboClients = (this.clients || [])
        .filter((c) => (c.clientName || "").toLowerCase().includes(query))
        .slice(0, 8);
      this.clientsLoading = false;
    },
    onSearchItem(q) {
      this.itemsLoading = true;
      this.debouncedFetchItems(q.trim());
    },
    async loadDuplicateQuote() {
      const id = this.lastDuplicateQuoteInfo?.quoteId;
      // console.debug("[dup] about to load", {
      //   lastDuplicateQuoteInfo: this.lastDuplicateQuoteInfo,
      //   id,
      // });
      if (!id) return;

      this.dupLoading = true;
      this.dupError = "";
      this.dupQuote = null;

      try {
        const { data } = await axiosInstance.get(`/quote/${id}`, {
          withCredentials: true,
        });
        // console.debug("[dup] GET /quote/:id response", data);

        // accetta sia {quote:{...}} sia {...} diretto
        const qRaw = data?.quote ?? data ?? {};
        // documents sia in quote che top-level
        this.dupDocuments = qRaw.documents ?? data?.documents ?? [];

        // parse location
        let parsedLocation = null;
        try {
          parsedLocation = asLoc(qRaw.location) || null;
        } catch {
          parsedLocation = null;
        }

        const items = (qRaw.quote_items || qRaw.items || []).map((qi) => {
          const cat = qi.item?.category || qi.category || "";
          const isBoxBased = isBoxBasedCategory(cat);
          return {
            category: cat,
            itemName: qi.item?.itemName || qi.item?.subBrand || qi.itemName,
            brand: qi.item?.subBrand || qi.brand,
            boxQuantity: isBoxBased ? qi.quantity : 0,
            pieces: isBoxBased ? 0 : qi.quantity,
            mqQuantity: isBoxBased ? mqFromApi(qi.mqQuantity) : null,
            iva: qi.iva ?? 22,
            price: Number(qi.price ?? 0),
            discountedPrice:
              qi.discountedPrice != null ? Number(qi.discountedPrice) : null,
          };
        });

        this.dupQuote = {
          ...qRaw,
          location: parsedLocation,
          totalPrice: qRaw.totalPrice ?? data?.totalPrice ?? null,
          items,
        };

        // console.debug("[dup] normalized dupQuote", this.dupQuote);
      } catch (e) {
        // console.error("[dup] load error", e?.response || e);
        this.dupError =
          e?.response?.data?.message ||
          "Impossibile caricare il preventivo esistente.";
      } finally {
        this.dupLoading = false;
      }
    },

    openDuplicateModal(quoteId, address) {
      this.lastDuplicateQuoteInfo = {
        quoteId: quoteId ?? null,
        address: address ?? null,
      };
      this.dupError = "";
      this.dupQuote = null;
      this.showDuplicateModal = true;

      // 👇 evita di affidarti solo ai watcher
      if (this.lastDuplicateQuoteInfo.quoteId) {
        this.loadDuplicateQuote();
      }
    },

    closeDuplicateModal() {
      this.showDuplicateModal = false;
    },

    // util formattazioni (riusate nel template)
    number(v) {
      return (typeof v === "number" ? v : Number(v || 0)).toFixed(2);
    },
    money(v) {
      return `€ ${this.number(v)}`;
    },
    formatDocName(name) {
      return (
        (name ?? "")
          .toString()
          // prima togli eventuale ".dev" immediatamente prima di ".pdf"
          .replace(/\.dev(?=\.pdf$)/i, "")
          // poi rimuovi "_N_<numero>.pdf" in fondo
          .replace(/_N_\d+\.pdf$/i, "")
      );
    },
    formatToLocalDate,

    // azioni footer
    onChangeAddress() {
      this.showDuplicateModal = false;
      this.$nextTick(() => document.getElementById("autocomplete")?.focus());
    },
    async onDuplicateWithEdit() {
      const sourceId = this.lastDuplicateQuoteInfo?.quoteId;
      this.showDuplicateModal = false;

      if (!sourceId) return;

      try {
        // se il dettaglio non è già caricato, lo carico ora
        if (!this.dupQuote || this.dupQuote.id !== sourceId) {
          this.dupLoading = true;
          const { data } = await axiosInstance.get(`/quote/${sourceId}`, {
            withCredentials: true,
          });
          const loc = asLoc(data?.quote?.location);
          this.dupQuote = { ...data.quote, location: loc };
        }

        const q = this.dupQuote;

        // mappo le righe dal server -> formData.items
        const mappedItems = (q.quote_items || [])
          .map((qi) => {
            if (qi.item) {
              const cat = qi.item.category;
              const isBoxBased = isBoxBasedCategory(cat);
              return {
                itemId: qi.item.id,
                category: cat,
                boxQuantity: isBoxBased ? qi.quantity : 0,
                pieces: isBoxBased ? 0 : qi.quantity,
                mqQuantity: isBoxBased ? mqFromApi(qi.mqQuantity) : null,
                price: Number(qi.price).toFixed(2),
                discountedPrice:
                  qi.discountedPrice != null
                    ? Number(qi.discountedPrice)
                    : null,
                iva: qi.iva ?? 22,
              };
            }
            return null;
          })
          .filter(Boolean);

        // cache per etichette/nomi in tabella
        (q.quote_items || []).forEach((qi) => {
          if (qi.item) this.selectedByKey[KEY.STOCK(qi.item.id)] = qi.item;
        });

        // compilo la form con i dati del preventivo esistente
        this.formData = {
          ...this.formData,
          clientId: q.clientId,
          payment_method: q.payment_method || "",
          technical_queries: q.technical_queries || "",
          items: mappedItems,
          location: {
            name: "",
            address: "",
            placeId: "",
            latitude: "",
            longitude: "",
          }, // ← SVUOTO
        };

        this.newItem = this.resetNewItem();

        this.$nextTick(() => document.getElementById("autocomplete")?.focus());
        this.$toast.info(
          `Contenuto del preventivo #${q.id} copiato. Inserisci un indirizzo diverso e salva.`
        );
      } catch (e) {
        this.$toast.error("Impossibile duplicare questo preventivo ora.");
      } finally {
        this.dupLoading = false;
      }
    },
    onViewedExisting() {
      // opzionale: analytics/log
    },

    categoryHintForRow(row) {
      if (row?.category) return row.category;
      return "STOCK";
    },
    rowCategoryGroup(row) {
      const it = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      return getCategoryGroup(it?.category);
    },
    isStockTiles(row) {
      return this.rowCategoryGroup(row) === "area";
    },
    qtyCell(row) {
      const group = this.rowCategoryGroup(row);
      if (group === "area" || group === "linear")
        return Number(row.boxQuantity || 0);
      return Number(row.pieces || row.quantity || 0);
    },
    getItemFromStore(id) {
      if (!id) return {};

      const key = KEY.STOCK(id);

      if (this.selectedByKey[key]) return this.selectedByKey[key];

      const stk =
        (this.items || []).find((i) => i.id === id) ||
        (this.filteredItems || []).find((i) => i.id === id);
      if (stk) {
        this.selectedByKey[key] = stk;
        return stk;
      }
      return {};
    },

    // Mappa azioni store
    ...mapActions(["uploadQuoteDocument", "createOrder"]),

    itemSearchLabel(it) {
      if (!it) return "";
      return it.itemName
        ? `${it.itemName} ${it.measureDesc || ""}`.trim()
        : `${it.subBrand || ""} ${it.fixtureType || ""} ${
            it.fixturePosition || ""
          }`.trim();
    },

    // Riga secondaria del risultato ricerca: brand + formato + finiture.
    itemFormatFinish(it) {
      return [it?.brand, it?.formatLabel, it?.finish]
        .filter(Boolean)
        .join(" · ");
    },

    warehouseCount(item) {
      const stock = Number(item?.warehouse?.inWarehouse ?? item?.inWarehouse);
      return Number.isFinite(stock) ? stock : 0;
    },

    isOrderableOutOfStock(item) {
      return !!item?.id && this.warehouseCount(item) <= 0;
    },

    /* Giacenza mostrata nell'unità di vendita: mq/ml per gli articoli a
       scatola (le scatole restano nel tooltip), pezzi per gli altri. */
    /* Articolo venduto a scatola ma senza mq/ml per scatola: le scatole non
       sono calcolabili, quindi giacenza e quantità da ordinare non vengono
       mostrate (sarebbero numeri inventati). */
    hasBoxData(item) {
      const group = getCategoryGroup(item?.category);
      if (group !== "area" && group !== "linear") return true;
      return itemPerBox(item) > 0;
    },

    rowHasBoxData(row) {
      return this.hasBoxData(this.rowStockItem(row));
    },

    stockLabel(item) {
      const count = this.warehouseCount(item);
      const group = getCategoryGroup(item?.category);
      if (group !== "area" && group !== "linear") return `${count} sc.`;
      const perBox = itemPerBox(item);
      // senza mq/ml per scatola la giacenza in mq non è ricavabile
      if (!perBox) return "—";
      const unit = group === "linear" ? "ml" : "mq";
      return `${formatDecimal(quantityFromBoxes(count, perBox))} ${unit}`;
    },

    stockTitle(item) {
      const count = this.warehouseCount(item);
      const group = getCategoryGroup(item?.category);
      if (group === "linear")
        return itemPerBox(item)
          ? `${count} ${count === 1 ? "confezione" : "confezioni"} in magazzino`
          : "Giacenza non calcolabile: manca ML / confezione nella scheda articolo";
      if (group === "area")
        return itemPerBox(item)
          ? `${count} ${count === 1 ? "scatola" : "scatole"} in magazzino`
          : "Giacenza non calcolabile: manca M² / scatola nella scheda articolo";
      return `${count} pz in magazzino`;
    },

    isQtyExceedingStock(row) {
      const item = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      if (!item?.id) return false;
      const stock = this.warehouseCount(item);
      if (stock <= 0) return false;
      return this.qtyCell(row) > stock;
    },

    /* mq/ml scritti a mano per riga, indicizzati per itemId: il PDF li usa al
       posto della quantità ricavata dalle scatole. */
    mqOverridesForPdf() {
      const map = {};
      (this.formData.items || []).forEach((row) => {
        const mq = Number(row?.mqQuantity);
        if (row?.itemId && mq > 0) map[row.itemId] = mq;
      });
      return map;
    },

    /* mq/ml digitati nel form, se validi (altrimenti null: la riga userà
       l'equivalente delle scatole) */
    typedMqQuantity() {
      if (!this.showMqField) return null;
      const n = Number(this.mqInput);
      return n > 0 ? n : null;
    },

    /* Allinea il campo mq alla quantità già presente in newItem (es. quando si
       riseleziona un articolo che ha già una quantità impostata). */
    syncMqInputFromBoxes() {
      const perBox = perBoxOrFallback(this.mqPerBox);
      const boxes = Number(this.newItem.boxQuantity) || 0;
      this.mqInput = boxes ? quantityFromBoxes(boxes, perBox) : "";
    },

    /* mq/ml per scatola della riga: 0 solo se l'articolo non è venduto a
       scatola, altrimenti il dato dell'articolo (o 1 se manca) */
    rowPerBox(row) {
      const group = this.rowCategoryGroup(row);
      if (group !== "area" && group !== "linear") return 0;
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      const perBox =
        group === "linear"
          ? Number(it.mlPerBox) || 0
          : Number(it.sqmPerBox) || 0;
      return perBoxOrFallback(perBox);
    },

    /* Unità della colonna quantità: mq/ml per gli articoli a scatola, pz per gli
       altri. Le scatole restano la quantità del preventivo ma non si mostrano. */
    rowQtyUnit(row) {
      const group = this.rowCategoryGroup(row);
      if (!this.rowPerBox(row)) return group === "linear" ? "ml" : "pz";
      return group === "linear" ? "ml" : "mq";
    },

    rowQtyStep(row) {
      return this.rowPerBox(row) ? "any" : "1";
    },

    /* Valore in colonna quantità: i mq/ml scritti dall'operatore (non riscritti),
       con fallback all'equivalente delle scatole; pezzi per gli altri articoli */
    rowQtyValue(row) {
      const perBox = this.rowPerBox(row);
      if (!perBox) return this.qtyCell(row);
      const typed = Number(row.mqQuantity);
      if (typed > 0) return row.mqQuantity;
      return quantityFromBoxes(Number(row.boxQuantity) || 0, perBox);
    },

    rowQtyTitle(row) {
      const perBox = this.rowPerBox(row);
      if (!perBox) return "Quantità in pezzi";
      // senza mq/ml per scatola le scatole non sono calcolabili: si dice
      // perché, invece di mostrare un numero inventato
      if (!this.rowHasBoxData(row)) {
        return "Scatole non calcolabili: completa la scheda articolo";
      }
      // scatole ricalcolate dai mq mostrati con il dato corrente dell'articolo:
      // boxQuantity salvato può essere vecchio (scheda completata dopo il
      // preventivo). È lo stesso calcolo che l'API rifà alla conferma.
      const requested = Number(this.rowQtyValue(row)) || 0;
      const boxes = requested > 0 ? boxesFromQuantity(requested, perBox) : 0;
      const isLinear = this.rowCategoryGroup(row) === "linear";
      const label =
        boxes === 1
          ? isLinear
            ? "confezione"
            : "scatola"
          : isLinear
          ? "confezioni"
          : "scatole";
      const unit = isLinear ? "ml" : "mq";
      const total = formatDecimal(quantityFromBoxes(boxes, perBox));
      return `${boxes} ${label} intere (${total} ${unit}) per i ${formatDecimal(
        requested
      )} ${unit} richiesti`;
    },

    updateRowQty(row, val, inputEl = null) {
      const group = this.rowCategoryGroup(row);
      const perBox = this.rowPerBox(row);
      const requested = Number(val) || 0;
      // per togliere l'articolo si usa il pulsante rimuovi, non la quantità 0
      if (requested <= 0) {
        this.$toast.error(
          "La quantità deve essere maggiore di 0: usa il pulsante rimuovi per eliminare l'articolo."
        );
        if (inputEl) inputEl.value = this.rowQtyValue(row);
        return;
      }
      if (perBox) {
        // l'operatore scrive i mq/ml: il valore resta quello digitato, le scatole
        // intere da ordinare sono derivate per il magazzino
        row.mqQuantity = requested;
        const boxes = Math.max(1, boxesFromQuantity(requested, perBox));
        row.boxQuantity = boxes;
        const storeItem = this.getItemFromStore(
          row.itemId,
          this.categoryHintForRow(row)
        );
        row.pieces = boxes * (storeItem?.piecesPerBox || 1);
        return;
      }
      const n = Math.max(1, Math.round(requested));
      if (group === "area" || group === "linear") {
        row.boxQuantity = n;
        const storeItem = this.getItemFromStore(
          row.itemId,
          this.categoryHintForRow(row)
        );
        row.pieces = n * (storeItem?.piecesPerBox || 1);
      } else {
        row.pieces = n;
      }
      // il binding :value non si aggiorna se il valore arrotondato coincide con
      // quello già in stato: riallineo il campo a mano
      if (inputEl && +inputEl.value !== n) inputEl.value = n;
    },

    /* Articolo della riga, risolto dallo store (le righe portano solo l'id) */
    rowStockItem(row) {
      const itemId = row?.itemId ?? row?.id;
      if (row?.id && row?.category) return row;
      return this.getItemFromStore(itemId, this.categoryHintForRow(row));
    },

    /* Riga con scheda articolo incompleta: si evidenzia in tabella, così è
       chiaro cosa completare prima di confermare il preventivo. */
    isRowStockIncomplete(row) {
      return hasIncompleteStockData(this.rowStockItem(row));
    },

    rowStockWarning(row) {
      const item = this.rowStockItem(row);
      const missing = missingStockFields(item);
      if (!missing.length) return "";
      return `Scheda articolo incompleta (manca ${missing.join(
        ", "
      )}): completala prima di confermare il preventivo.`;
    },

    validateQuoteItemsBeforeSubmit() {
      const rows = this.formData.items || [];
      // nessuna riga a quantità 0: il preventivo non deve poter essere salvato
      const zeroQtyRow = rows.find((row) => this.qtyCell(row) < 1);
      if (zeroQtyRow) {
        const label = this.itemDisplay(zeroQtyRow)?.title || "articolo";
        this.errorMessage = `Quantità non valida per "${label}": inserisci almeno 1 o rimuovi l'articolo.`;
        this.$toast.error(this.errorMessage);
        return false;
      }
      return true;
    },

    isOrderQueued(item) {
      return !!item?.id && !!this.pendingOrderItems[item.id];
    },

    isOrderQueuedRow(row) {
      return !!row?.itemId && !!this.pendingOrderItems[row.itemId];
    },

    // Quantità da ordinare per una riga (scarto tra richiesta e giacenza)
    /* Quantità mancante espressa nell'unità della riga: per gli articoli a
       mq/ml le scatole da ordinare si traducono nei mq/ml corrispondenti
       (le scatole restano fra parentesi: è quello che si ordina davvero). */
    qtyToOrderLabel(row) {
      const boxes = this.qtyToOrder(row);
      const perBox = this.rowPerBox(row);
      const unit = this.rowQtyUnit(row);
      if (!perBox || unit === "pz") return `${boxes} pz`;
      const qty = formatDecimal(quantityFromBoxes(boxes, perBox));
      const isLinear = unit === "ml";
      const label =
        boxes === 1
          ? isLinear
            ? "confezione"
            : "scatola"
          : isLinear
          ? "confezioni"
          : "scatole";
      return `${qty} ${unit} (${boxes} ${label})`;
    },

    qtyToOrder(row) {
      const item = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      return this.orderQuantityForItem(item);
    },

    orderQuantityForItem(item) {
      if (!item?.id) return 1;

      const stock = this.warehouseCount(item);

      const row = (this.formData.items || []).find(
        (entry) => Number(entry?.itemId) === Number(item.id)
      );
      if (row) {
        const rowGroup = getCategoryGroup(item.category);
        const qty =
          rowGroup === "area" || rowGroup === "linear"
            ? Number(row.boxQuantity || row.quantity || 0)
            : Number(row.pieces || row.quantity || 0);
        if (qty > 0) {
          return stock > 0 ? Math.max(qty - stock, 1) : qty;
        }
      }

      if (this.newItem.itemId === item.id) {
        const g = getCategoryGroup(item.category);
        const qty =
          g === "area" || g === "linear"
            ? Number(this.newItem.boxQuantity || 0)
            : Number(this.newItem.pieces || 0);
        if (qty > 0) return stock > 0 ? Math.max(qty - stock, 1) : qty;
      }
      return 1;
    },

    buildPendingOrderNote(quoteId) {
      return `Ordine per preventivo #${quoteId}`;
    },

    async processPendingOrders(quoteId) {
      const itemIds = Object.keys(this.pendingOrderItems || {}).map(Number);
      if (!quoteId || !itemIds.length) return;

      const results = await Promise.allSettled(
        itemIds.map((itemId) =>
          this.createOrder({
            itemId,
            quantity: this.orderQuantityForItem(this.getItemFromStore(itemId)),
            notes: this.buildPendingOrderNote(quoteId, itemId),
          })
        )
      );

      const failed = results.filter((r) => r.status === "rejected");
      if (failed.length) {
        this.$toast.error(
          `${failed.length} carico/i merce non creato/i dopo il salvataggio del preventivo.`
        );
      } else {
        this.$toast.success(
          "Carichi merce collegati al preventivo creati con successo."
        );
      }
    },

    queueOrderFromQuoteItem(item) {
      if (!item?.id || this.isOrderQueued(item)) return;

      this.pendingOrderItems = {
        ...this.pendingOrderItems,
        [item.id]: true,
      };

      this.$toast.info(
        "Ordine messo in coda. Verrà creato al salvataggio del preventivo."
      );
    },

    unqueueOrderFromQuoteItem(item) {
      if (!item?.id || !this.isOrderQueued(item)) return;

      const next = { ...this.pendingOrderItems };
      delete next[item.id];
      this.pendingOrderItems = next;

      if (this.newItem.itemId === item.id) this.orderNote = "";

      this.$toast.info("Ordine rimosso dalla coda.");
    },

    toggleItemsList() {
      this.panelVisible = !this.panelVisible;
    },

    startSearch(type) {
      this.activeSearch = type; // 'client' o 'item'
      this.showDropdown = true;
      this.selectedIndex = -1;
      // azzera solo il campo “attivo”
      if (type === "client") this.searchQueryClient = "";
      if (type === "item") this.searchQueryItem = "";
    },

    handleKey(event) {
      if (!this.showDropdown) return;

      // Quale array devo navigare?
      let list;
      if (this.activeSearch === "client") {
        list = this.filteredClients;
      } else if (this.activeSearch === "item") {
        list = this.filteredItems;
      } else {
        list = [];
      }

      // ========== freccia giù ==========
      if (event.key === "ArrowDown") {
        this.selectedIndex =
          this.selectedIndex < list.length - 1 ? this.selectedIndex + 1 : 0;
        event.preventDefault();

        // ========== freccia su ==========
      } else if (event.key === "ArrowUp") {
        this.selectedIndex =
          this.selectedIndex > 0 ? this.selectedIndex - 1 : list.length - 1;
        event.preventDefault();

        // ========== ENTER ==========
      } else if (event.key === "Enter") {
        if (this.selectedIndex >= 0 && this.selectedIndex < list.length) {
          const chosen = list[this.selectedIndex];

          if (this.activeSearch === "client") {
            // selezione cliente
            this.formData.clientId = chosen.id;
            this.searchQueryClient = chosen.clientName;
          } else if (this.activeSearch === "item") {
            // selezione articolo
            this.newItem.itemId = chosen.id;
            this.searchQueryItem = chosen.itemName
              ? `${chosen.itemName} ${chosen.measureDesc}`
              : `${chosen.subBrand} ${chosen.fixtureType || ""} ${
                  chosen.fixturePosition || ""
                }`;
            // Prezzo di listino NETTO (IVA esclusa), invariato al cambio IVA.
            this.newItem.price = Number(chosen.price) || 0;
            // memorizza l'oggetto articolo completo
            // this.selectedItemById[chosen.id] = chosen;
            this.selectedByKey[KEY.STOCK(chosen.id)] = chosen;
          }
          this.showDropdown = false;
          this.selectedIndex = -1;
        }
        event.preventDefault();
      }
    },

    selectClient(client) {
      this.formData.clientId = client.id;
      this.searchQueryClient = client.clientName;
      this.hideDropdown();
    },
    selectItem(item) {
      this.newItem.itemId = item.id;
      this.orderNote = "";
      this.searchQueryItem = this.itemSearchLabel(item);
      // const item =
      // memorizza l'oggetto articolo completo
      // this.selectedItemById[item.id] = item;
      this.selectedByKey[KEY.STOCK(item.id)] = item;
      // Prezzo di listino NETTO (IVA esclusa), invariato al cambio IVA.
      this.newItem.price = Number(item.price) || 0;
      // Prezzo scontato: inizialmente vuoto (l'operatore lo digita se serve).
      this.newItem.discountedPrice = "";
      // il campo mq deve riflettere la quantità dell'articolo appena scelto
      this.syncMqInputFromBoxes();
      this.hideDropdown();
    },

    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
        this.selectedIndex = -1;
        this.activeSearch = null;
      }, 300);
    },

    nameForDisplay(src) {
      return this.itemDisplayFromObj(src || {}).title || "Sconosciuto";
    },

    /**
     * Gestisce la selezione di un cliente dal dropdown.
     * Chiude il dropdown e aggiorna la searchQueryClient con il nome del cliente selezionato.
     */
    handleClientSelection() {
      this.showDropdown = false;
      this.searchQueryClient = this.getClientName(this.formData.clientId);
    },

    /* Numero opzionale non negativo: preserva lo zero (riga gratuita). Ritorna
       null per assente/vuoto/non numerico o negativo. */
    optionalNonNegativeNumber(value) {
      if (value === "" || value === null || value === undefined) return null;
      const parsed = Number(value);
      return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
    },

    async onSelectItem() {
      // 1) hide dropdown
      this.hideDropdown();
      // console.log("newitem", this.newItem);
      // 2) trova l'item selezionato
      const item = this.getItemFromStore(this.newItem.itemId, "STOCK");
      if (!item.id) return;

      // memorizza l'oggetto articolo completo
      // this.selectedItemById[item.id] = item;
      this.selectedByKey[KEY.STOCK(item.id)] = item;
      // 3) aggiorna la searchQuery per mostrare il nome selezionato
      this.searchQueryItem = item.itemName
        ? `${item.itemName} ${item.measureDesc}`
        : `${item.subBrand} ${item.fixtureType || ""} ${
            item.fixturePosition || ""
          }`;

      // 4) popola il prezzo di listino NETTO (IVA esclusa)
      this.newItem.price = Number(item.price) || 0;
    },

    addItem() {
      this.errorMessage = "";
      this.successMessage = "";

      const isAreaOrLinear =
        this.selectedItemGroup === "area" ||
        this.selectedItemGroup === "linear";
      const selected = this.selectedItem;

      const qty = isAreaOrLinear
        ? Number(this.newItem.boxQuantity || 0)
        : Number(this.newItem.pieces || 0);

      if (!this.newItem.itemId || qty <= 0 || !this.newItem.price) {
        this.errorMessage =
          "Compila tutti i campi prima di aggiungere un articolo.";
        this.$toast.error(this.errorMessage);
        return;
      }

      const fullObj = this.selectedItem;
      if (fullObj?.id) {
        this.selectedByKey[KEY.STOCK(fullObj.id)] = fullObj;
      }

      // Prezzo NETTO applicato: scontato se valorizzato (zero incluso),
      // altrimenti il listino netto. Nessuno sconto inviato al backend.
      const personalized = this.optionalNonNegativeNumber(
        this.newItem.discountedPrice
      );
      const appliedNet =
        personalized !== null ? personalized : Number(this.newItem.price) || 0;

      const existing = this.formData.items.find(
        (r) => r.itemId === this.newItem.itemId && r.iva === this.newItem.iva
      );

      if (existing) {
        if (isAreaOrLinear) {
          existing.boxQuantity = this.newItem.boxQuantity;
          existing.pieces = 0;
          existing.mqQuantity = this.typedMqQuantity();
        } else {
          existing.pieces = this.newItem.pieces;
        }
        existing.price = appliedNet;
        existing.iva = this.newItem.iva;

        this.$nextTick(() => {
          this.successMessage = "Quantità aggiornata per l'articolo esistente.";
          this.$toast.success(this.successMessage);
        });
        return; // niente push()
      }

      this.formData.items.push({
        itemId: this.newItem.itemId ?? null,
        boxQuantity: this.newItem.boxQuantity,
        pieces: this.newItem.pieces,
        // mq/ml scritti dall'operatore: base di calcolo dell'importo
        mqQuantity: this.typedMqQuantity(),
        // prezzo netto applicato (personalizzato se valorizzato, altrimenti listino)
        price: appliedNet,
        iva: this.newItem.iva,
        category: selected.category || "STOCK",
      });
      // console.log("formData.items: ", this.formData.items);
      this.$nextTick(() => {
        this.successMessage = "Articolo aggiunto con successo.";
        this.$toast.success(this.successMessage);
      });
      this.newItem = {
        itemId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        discountedPrice: "",
        iva: 0,
        category: "",
      };
      this.searchQueryItem = "";
      this.showDropdown = false;
    },

    removeItem(index) {
      this.formData.items.splice(index, 1);
    },

    saveToLocalStorage(key, data) {
      localStorage.setItem(key, JSON.stringify(data));
    },

    loadFromLocalStorage(key) {
      const savedData = localStorage.getItem(key);
      if (savedData) {
        return JSON.parse(savedData);
      }
      return null;
    },

    cap(w) {
      const s = (w || "").toString().trim();
      return s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : "";
    },

    itemDisplay(row) {
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      return this.itemDisplayFromObj(it);
    },

    // Usa la stessa logica di itemDisplay ma partendo da id+categoria
    itemDisplayById(id, categoryHint) {
      const it = this.getItemFromStore(id, categoryHint) || {};
      // riusa la parte di formattazione dentro itemDisplay:
      // copiamo la stessa logica in una funzione dedicata
      return this.itemDisplayFromObj(it);
    },

    // Estrae { title, meta } da un oggetto item già risolto
    itemDisplayFromObj(it = {}) {
      const Cap = (s) =>
        (s || "")
          .toString()
          .trim()
          .replace(/^\w/, (c) => c.toUpperCase());

      // ---- GRUPPO AREA (piastrelle, rivestimenti, parquet, laminati, decking) ----
      if (getCategoryGroup(it.category) === "area") {
        const title = it.itemName || "Articolo";
        const dim =
          it.measureDesc ||
          it.formatLabel ||
          (it.widthCm && it.heightCm
            ? `${it.widthCm}×${it.heightCm} cm`
            : null);
        const meta =
          [
            dim,
            it.surface,
            it.thicknessMm ? `${it.thicknessMm}mm` : null,
            it.color,
          ]
            .filter(Boolean)
            .join(" · ") ||
          it.category ||
          "";
        return { title: title || "Articolo", meta };
      }

      // ---- ALTRI GRUPPI ----
      const title =
        it.itemName ||
        [it.brand, it.subBrand].filter(Boolean).join(" \u2192 ").trim() ||
        "Articolo";

      const T = Cap(it.fixtureType || "");
      const P =
        it.fixturePosition === "terra"
          ? "a terra"
          : Cap(it.fixturePosition || "");

      // se ho info di tipo/posizione le mostro; altrimenti fallback alla subCategory (es. "Sanitari"/"Altro")
      const metaParts = [T, P].filter(Boolean);
      const meta = metaParts.length
        ? metaParts.join(" ")
        : Cap(it.subCategory || "");

      return { title, meta };
    },

    // ⚠️ Back-compat: ora usa la nuova formattazione e restituisce solo il titolo
    getItemName(id, categoryHint) {
      return this.itemDisplayById(id, categoryHint).title;
    },

    getClientName(clientId) {
      const client = this.clients.find((c) => c.id === clientId);
      return client ? client.clientName : "Sconosciuto";
    },

    formatIva(iva) {
      const percentageSymbol = "%";
      return `${iva} ${percentageSymbol}`;
    },

    formatPrice(price) {
      const currencySymbol = "€"; // Cambia in "$" per il dollaro
      return `${currencySymbol} ${formatDecimal(price)}`;
    },

    unitForRow(row) {
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      if (
        String(row?.itemName || it?.itemName || "")
          .toLowerCase()
          .includes("battiscopa")
      )
        return "€/mL";
      const group = getCategoryGroup(it.category);
      if (group === "area") return "€/mq";
      if (group === "linear") return "€/ml";
      return "€/pz";
    },

    mqForRow(row) {
      // console.log("row", row);
      const item = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      // console.log("mqForRow item: ", item);
      const sqmPerBox = Number(item.sqmPerBox) || 0;
      const boxes = Number(row.boxQuantity) || 0;
      const total = sqmPerBox * boxes;
      return total ? total.toFixed(2) : "";
    },

    resetNewItem() {
      return {
        itemId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        discountedPrice: "",
        category: "",
        quantity: 0,
        iva: 0,
      };
    },

    async onCreateQuoteAndGeneratePdf({ generatePdf = true } = {}) {
      this.errorMessage = "";
      this.successMessage = "";

      // 0) Validazioni minime (indirizzo facoltativo; modalità obbligatoria)
      if (this.formData.items.length === 0) {
        this.errorMessage = "Aggiungi almeno un articolo prima di salvare";
        this.$toast.error(this.errorMessage);
        return;
      }
      if (!this.formData.deliveryType) {
        this.errorMessage =
          "Seleziona la modalità: consegna o ritiro, prima di salvare";
        this.$toast.error(this.errorMessage);
        return;
      }

      try {
        // 1) Se hai un articolo parzialmente compilato nei campi input, aggiungilo prima del salvataggio
        if (
          this.newItem.itemId &&
          (this.newItem.boxQuantity || this.newItem.pieces)
        ) {
          this.formData.items.push({
            ...this.newItem,
            mqQuantity: this.typedMqQuantity(),
          });
        }

        if (!this.validateQuoteItemsBeforeSubmit()) return;

        // 2) Salvataggio preventivo
        const payload = {
          ...this.formData,
          technical_queries: (this.formData.technical_queries || "").trim(),
        };

        if (payload.date && payload.date.length === 10) {
          payload.date = new Date(payload.date + "T00:00:00").toISOString();
        }

        const sanitize = (s) => (s || "").replace(/\p{C}+/gu, "");
        payload.technical_queries = sanitize(payload.technical_queries);
        // console.log("Creating quote with payload:", payload);
        const response = await this.$store.dispatch("createQuote", payload);
        this.response = response; // mantengo per compatibilità col tuo codice
        // console.log("Create quote response:", response);

        if (response?.status !== 200 && response?.status !== 201) {
          // ⬇️ ramo 409
          if (
            response?.status === 409 &&
            response?.data.code === "QUOTE_DUPLICATE"
          ) {
            const d = response?.data || {};
            const details = (typeof d.details === "object" && d.details) || {};
            const id =
              details.quoteId ??
              details.id ??
              details.quote?.id ??
              d.quoteId ??
              d.id ??
              null;

            const address =
              details.address ?? this.formData?.location?.address ?? null;

            this.$toast.error(
              d.message ||
                d.details ||
                "Esiste già un preventivo per questo cliente allo stesso indirizzo in corso..."
            );
            this.openDuplicateModal(id, address);
            return;
          }

          // ...altri errori
          this.errorMessage =
            response.data?.details ||
            response.data?.message ||
            "Impossibile creare il preventivo.";
          this.$toast.error(this.errorMessage);
          this.successMessage = "";
          return;
        }

        // 3) Messaggio OK salvataggio
        // Solo l'esito: nessun contenuto del preventivo, nessun importo.
        trackEvent(EVENTS.QUOTE_CREATED, {
          action: "create",
          kind: "quote",
          outcome: "success",
        });

        this.successMessage =
          response.data?.message || "Preventivo creato con successo!";
        this.$toast.success(this.successMessage);

        const quoteWrap = response.data?.quote || {};
        const createdQuoteId = Number(quoteWrap?.newQuote?.id || 0);
        await this.processPendingOrders(createdQuoteId);

        // 4) Se richiesto, genera + carica + scarica PDF
        if (generatePdf) {
          const nq = quoteWrap.newQuote;
          const quoteForPdf = {
            ...nq,
            totalPrice: quoteWrap.totalPrice ?? nq?.totalPrice,
            Client: {
              clientName: nq.clientName,
              phoneNumber: nq.phoneNumber,
              pec: nq.pec,
              email: nq.email,
              vatNumber: nq.vatNumber,
              taxCode: nq.taxCode,
              companyName: nq.companyName,
              legalHeadquarters: nq.legalHeadquarters,
            },
          };
          await generateQuotePdf({
            quote: quoteForPdf,
            toast: this.$toast,
            uploadQuoteDocument: (payload) =>
              this.$store.dispatch("uploadQuoteDocument", payload),
            mqOverrides: this.mqOverridesForPdf(),
          });
        }

        // 5) Reset campi (comuni)
        this.formData = {
          location: {
            name: "",
            address: "",
            placeId: "",
            latitude: "",
            longitude: "",
          },
          technical_queries: "",
          clientId: "",
          items: [],
          date: "",
          payment_method: "",
          deliveryType: "",
        };

        this.newItem = this.resetNewItem();
        this.searchQueryItem = "";

        this.resetLocation();

        // 6) Redirect pagina preventivi
        setTimeout(() => {
          this.navigationConfirmed = true;
          this.$router.push({ name: "quotes" });
          this.errorMessage = "";
          this.successMessage = "";
        }, 4000);
      } catch (error) {
        const resp = error?.response;

        // ⬇️ ramo 409
        if (resp?.status === 409 && resp?.data?.code === "QUOTE_DUPLICATE") {
          const d = resp?.data || {}; // usa quello che hai a disposizione
          const details = (typeof d.details === "object" && d.details) || {};
          const id =
            details.quoteId ??
            details.id ??
            details.quote?.id ??
            d.quoteId ??
            d.id ??
            null;

          const address =
            details.address ?? this.formData?.location?.address ?? null;

          this.$toast.error(
            d.message ||
              d.details ||
              "Esiste già un preventivo per questo cliente allo stesso indirizzo in corso..."
          );
          this.openDuplicateModal(id, address);
          return;
        }

        // ...altri errori
        this.errorMessage =
          resp?.data?.message ||
          resp?.data?.details ||
          resp?.data?.error ||
          "Errore durante la creazione del preventivo.";
        this.$toast.error(this.errorMessage);
        this.successMessage = "";
      }
    },

    resetLocation() {
      this.formData.location = {
        name: "",
        address: "",
        placeId: "",
        latitude: "",
        longitude: "",
      };
    },

    handlePlaceChange() {
      // Puoi gestire azioni aggiuntive dopo il cambio del luogo
    },

    // Prima ricerca (nuova query): pagina 1, svuota subito i risultati e reset
    // su 404/errore. `reqId` progressivo: le risposte obsolete (digitazione
    // rapida o cambio pagina in volo) vengono ignorate.
    fetchItems(q) {
      const query = (q || "").trim();
      const reqId = ++this.itemsRequestId;
      this.itemsSearchQuery = query;
      this.itemsPage = 1;
      this.itemsRequestedPage = null;
      this.itemsTotalPages = 1;
      this.itemsTotalItems = null;
      // I risultati della ricerca precedente non devono restare visibili né
      // selezionabili durante il caricamento della nuova query.
      this.filteredItems = [];
      this.requestItemsPage(query, 1, reqId, true);
    },
    // Cambio pagina (stessa query): imposta subito la pagina richiesta
    // (pending), poi la carica. Un click su un'altra pagina mentre una è in
    // volo la "supera" (nuovo reqId); i doppioni verso la pagina già richiesta o
    // già caricata sono ignorati. I risultati sostituiscono, non concatenano.
    onItemPageChange(page) {
      const target = Number(page);
      if (!Number.isInteger(target)) return;
      if (target < 1 || target > this.itemsTotalPages) return;
      const active =
        this.itemsRequestedPage != null
          ? this.itemsRequestedPage
          : this.itemsPage;
      if (target === active) return; // niente richieste duplicate
      this.itemsRequestedPage = target;
      const reqId = ++this.itemsRequestId;
      this.requestItemsPage(this.itemsSearchQuery, target, reqId, false);
    },
    // GET condivisa. `isFirstSearch` distingue la gestione errori. Una risposta
    // obsoleta (reqId superato) esce subito senza toccare risultati, pagina o
    // stato loading/pending.
    requestItemsPage(query, page, reqId, isFirstSearch) {
      this.itemsLoading = true;
      axiosInstance
        .get("/item/get-all", { params: { page, limit: 10, search: query } })
        .then(({ data }) => {
          if (reqId !== this.itemsRequestId) return; // risposta obsoleta
          this.filteredItems = data.results || [];
          const p = data.pagination || {};
          this.itemsPage = p.currentPage || page;
          this.itemsTotalPages = p.totalPages || 1;
          this.itemsTotalItems = p.totalItems ?? null;
          this.itemsRequestedPage = null; // pagina caricata: pending azzerato
        })
        .catch((err) => {
          if (reqId !== this.itemsRequestId) return; // risposta obsoleta
          const is404 = err?.response?.status === 404;
          if (!is404) console.error(err);
          if (isFirstSearch) {
            // Nessun risultato / errore in prima ricerca: lista vuota, pagina 1.
            this.filteredItems = [];
            this.itemsPage = 1;
            this.itemsTotalPages = 1;
            this.itemsTotalItems = is404 ? 0 : null;
          }
          // Cambio pagina fallito: si mantengono risultati e itemsPage caricati;
          // si azzera solo la pagina richiesta e si riabilitano i controlli.
          this.itemsRequestedPage = null;
        })
        .finally(() => {
          if (reqId === this.itemsRequestId) this.itemsLoading = false;
        });
    },
    // --- pulizia selezione articolo di magazzino ---
    clearItemSelection() {
      const iva = this.newItem.iva ?? 22; // preserva l'IVA scelta (anche 0%)
      Object.assign(this.newItem, this.resetNewItem(), { iva });
      this.searchQueryItem = "";
      this.orderNote = "";
    },

    // Apertura modale "Crea articolo".
    openCreateItemModal() {
      console.log("openCreateItemModal"); // DEBUG temporaneo
      this.showCreateItemModal = true;
    },

    // Articolo creato dalla modale: lo rende disponibile nella ricerca e lo
    // auto-seleziona riusando la logica esistente selectItem().
    async onItemCreated({ item, itemCode, message }) {
      let createdItem = item;

      // Fallback robusto: se la response non è completa, rileggo l'articolo
      // con lo stesso endpoint/param (search) usato dalla ricerca del preventivo.
      if (!createdItem || createdItem.id == null || createdItem.price == null) {
        const { data } = await axiosInstance.get("/item/get-all", {
          params: { page: 1, limit: 10, search: itemCode },
        });
        const results = data?.results || [];
        createdItem =
          results.find(
            (it) => it.itemCode === itemCode || it.item_code === itemCode
          ) ||
          results[0] ||
          createdItem;
      }

      if (!createdItem?.id) {
        this.$toast.error("Articolo creato ma non recuperabile.");
        return;
      }

      if (!this.filteredItems.some((it) => it.id === createdItem.id)) {
        this.filteredItems = [createdItem, ...this.filteredItems];
      }

      this.selectItem(createdItem);
      this.showCreateItemModal = false;
      this.$toast.success(message || "Articolo creato e selezionato");
    },
  },

  watch: {
    // 🔄 Ricerca + pulizia selezione se l'utente svuota il campo
    searchQueryItem(newQ, oldQ) {
      if (oldQ && !newQ.trim() && this.newItem.itemId)
        this.clearItemSelection();
      this.debouncedFetchItems(newQ.trim());
    },

    /* Deselezione articolo (addItem, clearItemSelection, reset form): svuota
       anche il campo mq */
    "newItem.itemId"(id) {
      if (!id) this.mqInput = "";
    },

    /* mq/ml digitati -> scatole intere del preventivo (arrotondamento per
       eccesso). Il campo resta com'è stato scritto: nessuna riscrittura. */
    mqInput(v) {
      if (!this.showMqField) return;
      const perBox = perBoxOrFallback(this.mqPerBox);
      const boxes = boxesFromQuantity(v, perBox);
      this.newItem.boxQuantity = boxes;
      const ppb = this.selectedItem.piecesPerBox || 1;
      this.newItem.pieces = this.selectedItemGroup === "area" ? boxes * ppb : 0;
    },

    // aggiornamento riga esistente (come avevi)
    newItem: {
      deep: true,
      handler(nv) {
        if (!nv) return;

        // Trova la riga esistente in base all'id correntemente selezionato
        const id = nv.itemId;
        // console.log({ nv: nv, id: id });
        if (!id) return;

        const key = "itemId";
        // console.log("key", key);
        // console.log("formdata", this.formData.items);
        const row = this.formData.items.find((x) => x[key] === id);
        // console.log("row", row);

        // Se non è stata ancora aggiunta con addItem(), non toccare nulla
        if (!row) return;

        const group = getCategoryGroup(this.selectedItem?.category);
        const isBoxBased = group === "area" || group === "linear";
        const qty = isBoxBased
          ? Number(nv.boxQuantity) || 0
          : Number(nv.pieces) || 0;
        // qty 0 = articolo appena riselezionato nel form (campo quantità ancora
        // vuoto): non azzerare la riga già presente in tabella
        if (qty > 0) {
          row.boxQuantity = isBoxBased ? qty : 0;
          row.pieces = isBoxBased ? 0 : qty;
          if (isBoxBased) row.mqQuantity = this.typedMqQuantity();
        }
        row.price = nv.price;
        row.iva = nv.iva;
        // console.log("row after update", row);
      },
    },
    //       this.selectedItem.category === "piastrelle"
    //         ? nv.boxQuantity
    //         : this.selectedItem.subCategory === "piastrelle"
    //         ? nv.sqmQuantity
    //         : nv.pieces || 0;
    //     row.quantity = qty;
    //     row.boxQuantity = nv.boxQuantity;
    //     row.pieces = nv.pieces;
    //     row.price = nv.price;
    //     row.iva = nv.iva;
    //   },
    //   deep: true,
    // },

    showDuplicateModal(v) {
      if (
        v &&
        this.lastDuplicateQuoteInfo &&
        this.lastDuplicateQuoteInfo.quoteId
      ) {
        this.loadDuplicateQuote();
      }
    },
    lastDuplicateQuoteInfo: {
      deep: true,
      handler(nv) {
        if (this.showDuplicateModal && nv && nv.quoteId) {
          this.loadDuplicateQuote();
        }
      },
    },
  },

  mounted() {
    this.panelVisible = window.innerWidth >= 768;
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
};
</script>

<style src="@/css/CreateQuotePage.css"></style>
